import { BUSINESS } from "@/lib/sleek";

// Renders nothing until BUSINESS.appStoreUrl is set (app approved).
export const AppStoreBadge = ({ testid = "app-store-badge" }) => {
  if (!BUSINESS.appStoreUrl) return null;
  return (
    <a
      href={BUSINESS.appStoreUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Download on the App Store"
      data-testid={testid}
      className="inline-block hover:opacity-80 transition-opacity"
    >
      <svg width="140" height="42" viewBox="0 0 140 42" role="img" aria-hidden="true">
        <rect x="0.5" y="0.5" width="139" height="41" rx="8" fill="#000" stroke="#a6a6a6" />
        <path
          d="M25.7 21.6c0-2.4 2-3.6 2.1-3.7-1.1-1.7-2.9-1.9-3.5-1.9-1.5-.2-2.9.9-3.7.9-.8 0-1.9-.9-3.2-.8-1.6 0-3.1 1-4 2.4-1.7 3-.4 7.4 1.2 9.8.8 1.2 1.8 2.5 3.1 2.4 1.2-.1 1.7-.8 3.2-.8s1.9.8 3.2.8c1.3 0 2.2-1.2 3-2.4.9-1.4 1.3-2.7 1.3-2.8-.1 0-2.6-1-2.7-3.9zM23.3 14.4c.7-.8 1.1-1.9 1-3-1 0-2.2.7-2.9 1.5-.6.7-1.2 1.9-1 3 1.1.1 2.2-.6 2.9-1.5z"
          fill="#fff"
        />
        <text x="38" y="17" fill="#fff" fontFamily="-apple-system, Helvetica, Arial, sans-serif" fontSize="9">Download on the</text>
        <text x="38" y="32" fill="#fff" fontFamily="-apple-system, Helvetica, Arial, sans-serif" fontSize="15" fontWeight="600">App Store</text>
      </svg>
    </a>
  );
};

export default AppStoreBadge;
